import React, { useState } from 'react';
import LinkedInPosts from '../components/LinkedInPosts';
import AutomotivePosts from '../components/AutomotivePosts';
import '../styles/dashboard.css';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('automotive');

  const tabs = [
    { id: 'automotive', label: 'Automotive' },
    { id: 'media', label: 'Media & Marketing' },
    { id: 'social', label: 'Social Analysis' }
  ];

  return (
    <div className="dashboard-container">
      <nav className="agent-nav">
        <a href="/agent/dexter" className="agent-link">Dexter</a>
        <a href="/agent/huxley" className="agent-link">Huxley</a>
        <a href="/agent/nova" className="agent-link">Nova</a>
        <a href="/agent/darcy" className="agent-link">Darcy</a>
      </nav>

      <div className="content-section">
        <div className="content-tabs">
          {tabs.map(tab => (
            <button 
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="content-panel">
          <div className={`panel-section ${activeTab === 'automotive' ? 'active' : ''}`}>
            <AutomotivePosts />
          </div>
          <div className={`panel-section ${activeTab === 'media' ? 'active' : ''}`}>
            {/* Media content */}
          </div>
          <div className={`panel-section ${activeTab === 'social' ? 'active' : ''}`}>
            <LinkedInPosts />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

